module.exports = __webpack_public_path__ + "img/shoppub_logo_v3.7d8fdc88.svg";